import { injectMemCommonEditorGlobalStyles } from "@mem-labs/common-editor";
import { backendApiClientManager, backendAuthApiClientManager } from "@/manager/backend-api-client";
import { cacheClientManager } from "@/manager/cache-client";
import { datadogLoggingClientManager } from "@/manager/datadog-logging-client";
import { loggerClientManager } from "@/manager/logging-client";
import { lowlightModule } from "@/modules/lowlight";
import { datadogRumClientManager } from "@/manager/datadog-rum-client";

export const initializeGlobalState = async () => {
  injectMemCommonEditorGlobalStyles();

  await backendApiClientManager.initialize({});
  await backendAuthApiClientManager.initialize({});
  await cacheClientManager.initialize({});
  await datadogLoggingClientManager.initialize({});
  await datadogRumClientManager.initialize({});
  await loggerClientManager.initialize({});

  lowlightModule.initialize();
};
